<script setup lang="ts">
import { useAuthStore } from '@/stores/auth'
import GoogleSignInButton from './GoogleSignInButton.vue'

const auth = useAuthStore()
</script>

<template>
  <div class="sign-in-prompt">
    <div class="prompt-card">
      <p v-if="auth.loadFailed" class="notice">
        Couldn't reach the server to restore your session.
        <button class="link-btn" @click="auth.loadUser">Retry</button>
      </p>
      <p v-else-if="auth.sessionExpired" class="notice">Your session expired. Please sign in again.</p>
      <h2>Sign in to continue</h2>
      <p>This page requires a Google account.</p>
      <GoogleSignInButton />
    </div>
  </div>
</template>

<style scoped>
.sign-in-prompt {
  max-width: 600px;
  margin: 0 auto;
  padding: 2rem 1rem;
}

.prompt-card {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 3rem 2rem;
  text-align: center;
}

.prompt-card h2 {
  margin: 0 0 0.5rem;
  color: #333;
}

.prompt-card p {
  color: #666;
  margin: 0 0 1.5rem;
}

.prompt-card .notice {
  color: #b45309;
  font-weight: 500;
}

.link-btn {
  background: none;
  border: none;
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
  font: inherit;
  padding: 0;
}
</style>
